import { first } from 'lodash';

import { UserRoles } from '@shared/enums/user-roles';
import { UserToGeneralRoleMapping } from '@shared/interfaces/user-to-general-role-mapping';
import { UserWithGeneralRole } from '@shared/interfaces/user-with-general-role';
import { RestUserModel } from '@shared/interfaces/user.interface';
import { IsUserExistingPipe } from '@shared/pipes/is-user-existing.pipe';

const isUserExisting = new IsUserExistingPipe();

export function combineUsersWithGeneralRoles(
  allUsers: RestUserModel[],
  allUserToGeneralRoleMapping: UserToGeneralRoleMapping[]
): UserWithGeneralRole[] {
  return allUsers.map(user => {
    const entry = first((allUserToGeneralRoleMapping || []).filter(item => item.userId === user.id));
    const roleId = entry?.roleId || null;
    const roleName = isUserExisting.transform(user) ? entry?.associatedRole.roleName || null : UserRoles.Unassigned;
    return {
      ...user,
      roleId,
      roleName,
    };
  });
}

function userWithoutRole(newUser) {
  if (isUserExisting.transform(newUser)) {
    return newUser;
  }

  newUser.roleName = UserRoles.Unassigned;
  return newUser;
}

function userWithGeneralRole(newUser, userRole) {
  newUser.roleName = isUserExisting.transform(newUser) ? userRole.roleName : UserRoles.Unassigned;

  return newUser;
}
